/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
	'expenseCategories/car-dealership': {
		width: 35,
		height: 36,
		viewBox: '0 0 35.4 36.1',
		data: `<path class="st0" d="M35.3,7.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.3-0.1-0.4l-2.6-6C32.4,0.2,32,0,31.6,0h-17
    c-0.4,0-0.7,0.2-0.9,0.6l-2.6,6c-0.2,0.6-0.2,1.3,0,2c0.5,1.1,1.4,2,2.5,2.4v6.3h2.2v-6c1.4,0,2.8-0.6,3.8-1.7c2,2.3,5.5,2.3,7.5,0
    c0.9,1.1,2.3,1.7,3.8,1.7v8.5h-0.2h-2.8v-6.6c0-0.5-0.4-0.9-0.9-0.9h-7.5c-0.5,0-0.9,0.4-0.9,0.9v6.4l0.6,2.1h12.3
    c0.5,0,0.9-0.4,0.9-0.9V11c1.1-0.4,2-1.3,2.5-2.4C35,8.4,35,8.2,35.1,8C35.4,7.7,35.4,7.4,35.3,7.2z M22.2,19.8h-1.9v-5.7h1.9V19.8z
     M26,19.8h-1.9v-5.7H26V19.8z M30.7,9.4C29.3,9.5,28,8.5,27.9,7c0-0.7-0.8-1.2-1.4-0.8C26.2,6.4,26,6.7,26,7.1
    c-0.1,1.4-1.4,2.5-2.8,2.4c-1.4,0.1-2.7-0.9-2.8-2.4c0-0.7-0.8-1.2-1.4-0.8c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,1.4-1.4,2.5-2.8,2.4
    c-1.1,0-2.2-0.6-2.7-1.6c-0.1-0.2-0.1-0.4,0-0.5L15.4,2H31l2.3,5.4c0.1,0.1,0.1,0.3,0.1,0.4C32.9,8.8,31.9,9.4,30.7,9.4z"/>
  <path class="st0" d="M22.3,22.8l-1.7-5.6c-0.4-1.3-1.6-2.2-2.9-2.1H6.4c-1.3,0-2.5,0.9-2.9,2.1l-1.7,5.6C0.7,23.3,0,24.3,0,25.6v6
    c0,0.8,0.7,1.5,1.5,1.5v1.5c0,0.9,0.7,1.6,1.5,1.5h1.5c0.9,0,1.5-0.7,1.5-1.5v-1.5h12.1v1.5c0,0.8,0.7,1.5,1.5,1.5h1.5
    c0.8,0,1.5-0.7,1.5-1.5v-1.5c0.8,0,1.5-0.7,1.5-1.5v-6C24.1,24.4,23.4,23.3,22.3,22.8z M6.4,18h11.3l1.4,4.5h-14L6.4,18z M6,29.3
    c-1.2,0-1.9-1.3-1.3-2.3s2-1,2.6,0c0.1,0.2,0.2,0.5,0.2,0.8C7.5,28.6,6.9,29.3,6,29.3z M18.1,29.3c-1.2,0-1.9-1.3-1.3-2.3s2-1,2.6,0
    c0.1,0.2,0.2,0.5,0.2,0.8C19.6,28.6,18.9,29.3,18.1,29.3L18.1,29.3z"/>
    `
	}
});
